/* ============================================
   GULP STORE LOCATOR — Vanilla JS
   ============================================ */

(function () {
  'use strict';

  var map = null;
  var markers = [];
  var cards = [];
  var activeRegion = 'all';
  var selectedIndex = -1;
  var nearestMarkerEl = null;

  /* ------ Haversine formula — distance in km ------ */
  function getDistanceKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) *
      Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  /* ------ Format distance for display ------ */
  function formatDistance(km) {
    if (km < 1) {
      return Math.round(km * 1000) + ' m away';
    }
    return km.toFixed(1) + ' km away';
  }

  /* ------ Custom map styles (brand muted) ------ */
  var mapStyles = [
    { elementType: 'geometry', stylers: [{ color: '#F5F0EB' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#3D2F2A' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#FFFFFF' }] },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [{ color: '#d2dde8' }]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#B5A99A' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#B5A99A' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#e0d9d0' }]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#B5A99A' }]
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{ color: '#e8e0d6' }]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#B5A99A' }]
    },
    {
      featureType: 'poi.business',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'transit',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#B5A99A' }]
    }
  ];

  /* ------ SVG marker icon ------ */
  function createMarkerIcon(color) {
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="40" viewBox="0 0 28 40">' +
      '<path d="M14 0C6.27 0 0 6.27 0 14c0 10.5 14 26 14 26s14-15.5 14-26C28 6.27 21.73 0 14 0z" fill="' + color + '"/>' +
      '<circle cx="14" cy="14" r="5" fill="#FFFFFF"/>' +
      '</svg>';
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(28, 40),
      anchor: new google.maps.Point(14, 40)
    };
  }

  var defaultIcon;
  var activeIcon;

  /* ------ Init map (Google Maps callback) ------ */
  window.initGulpMap = function () {
    var mapEl = document.getElementById('gulp-map');
    if (!mapEl) return;

    try {
      map = new google.maps.Map(mapEl, {
        center: { lat: -41.2, lng: 174.9 },
        zoom: 5,
        styles: mapStyles,
        disableDefaultUI: true,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
      });

      window.gulpMap = map;

      defaultIcon = createMarkerIcon('#3D2F2A');
      activeIcon = createMarkerIcon('#A8BDD4');

      initCards();
      createMarkers();
      bindSearch();
      bindPills();
      bindGeoButton();
    } catch (e) {
      console.error('GULP Map error:', e);
      mapEl.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100%;min-height:300px;padding:40px;text-align:center;color:#B5A99A;font-size:14px;">Map error: ' + e.message + '</div>';
      initCards();
      bindSearch();
      bindPills();
      bindGeoButton();
    }
  };

  /* ------ Google Maps auth failure handler ------ */
  window.gm_authFailure = function () {
    console.error('Google Maps authentication failed — check API key');
    var mapEl = document.getElementById('gulp-map');
    if (mapEl) {
      mapEl.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100%;min-height:300px;padding:40px;text-align:center;color:#B5A99A;font-size:14px;line-height:1.6;">Map authentication failed.<br>Check your Google Maps API key in the theme editor.</div>';
    }
  };

  /* ------ Fallback init (no API key) ------ */
  function initNoMap() {
    initCards();
    bindSearch();
    bindPills();
    bindGeoButton();
  }

  /* ------ Gather store cards ------ */
  function initCards() {
    cards = Array.prototype.slice.call(
      document.querySelectorAll('[data-store-card]')
    );

    cards.forEach(function (card, i) {
      card.setAttribute('data-index', i);
      card.addEventListener('click', function (e) {
        if (e.target.closest('.sl__card-directions')) return;
        selectStore(i, true);
      });
    });
  }

  /* ------ Create map markers ------ */
  function createMarkers() {
    if (!map) return;

    cards.forEach(function (card, i) {
      var lat = parseFloat(card.getAttribute('data-lat'));
      var lng = parseFloat(card.getAttribute('data-lng'));
      if (isNaN(lat) || isNaN(lng)) return;

      var marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: map,
        icon: defaultIcon,
        title: card.getAttribute('data-name')
      });

      marker._index = i;

      marker.addListener('click', function () {
        selectStore(i, false);
      });

      markers.push(marker);
    });
  }

  /* ------ Select a store ------ */
  function selectStore(index, panMap) {
    /* Deselect previous */
    cards.forEach(function (c) { c.classList.remove('is-selected'); });
    markers.forEach(function (m) { if (m.setIcon) m.setIcon(defaultIcon); });

    selectedIndex = index;
    var card = cards[index];
    if (!card) return;

    card.classList.add('is-selected');

    /* Scroll list to card */
    var list = card.closest('.sl__list');
    if (list) {
      list.scrollTo({
        top: card.offsetTop - list.offsetTop - 8,
        behavior: 'smooth'
      });
    }

    /* Highlight pin & pan map */
    if (map && panMap) {
      var marker = markers.find(function (m) { return m._index === index; });
      if (marker) {
        marker.setIcon(activeIcon);
        map.panTo(marker.getPosition());
        if (map.getZoom() < 10) map.setZoom(10);
      }
    } else {
      var markerNoMap = markers.find(function (m) { return m._index === index; });
      if (markerNoMap) {
        markerNoMap.setIcon(activeIcon);
      }
    }
  }

  /* ------ Search input ------ */
  function bindSearch() {
    var input = document.querySelector('.sl__search-input');
    if (!input) return;

    input.addEventListener('input', function () {
      filterCards();
    });
  }

  /* ------ Region pills ------ */
  function bindPills() {
    var pills = document.querySelectorAll('.sl__pill');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-selected', 'true');
        activeRegion = pill.getAttribute('data-region');
        filterCards();
      });
    });
  }

  /* ------ Filter logic ------ */
  function filterCards() {
    var input = document.querySelector('.sl__search-input');
    var query = input ? input.value.toLowerCase().trim() : '';
    var visibleCount = 0;

    cards.forEach(function (card, i) {
      var name = (card.getAttribute('data-name') || '').toLowerCase();
      var address = (card.getAttribute('data-address') || '').toLowerCase();
      var region = (card.getAttribute('data-region') || '');

      var matchesSearch = !query ||
        name.indexOf(query) !== -1 ||
        address.indexOf(query) !== -1 ||
        region.toLowerCase().indexOf(query) !== -1;

      var matchesRegion = activeRegion === 'all' || region === activeRegion;

      var visible = matchesSearch && matchesRegion;

      card.classList.toggle('is-hidden', !visible);

      /* Show/hide marker */
      var marker = markers.find(function (m) { return m._index === i; });
      if (marker) {
        marker.setVisible(visible);
      }

      if (visible) visibleCount++;
    });

    /* Show/hide no-results message */
    var noResults = document.querySelector('.sl__no-results');
    if (noResults) {
      noResults.classList.toggle('is-visible', visibleCount === 0);
    }

    /* Fit map to visible markers */
    if (map && markers.length > 0) {
      var bounds = new google.maps.LatLngBounds();
      var hasBounds = false;
      markers.forEach(function (m) {
        if (m.getVisible()) {
          bounds.extend(m.getPosition());
          hasBounds = true;
        }
      });
      if (hasBounds) {
        map.fitBounds(bounds, { top: 40, bottom: 40, left: 40, right: 40 });
        if (map.getZoom() > 14) map.setZoom(14);
      }
    }
  }

  /* ------ Geolocation: Find Nearest Store ------ */
  function bindGeoButton() {
    var btn = document.querySelector('[data-geo-btn]');
    if (!btn) return;

    /* Hide button entirely if geolocation not supported */
    if (!navigator.geolocation) {
      btn.style.display = 'none';
      var privacy = document.querySelector('.sl__geo-privacy');
      if (privacy) privacy.style.display = 'none';
      return;
    }

    btn.addEventListener('click', findNearestStore);
  }

  function findNearestStore() {
    var btn = document.querySelector('[data-geo-btn]');
    var label = btn ? btn.querySelector('[data-geo-label]') : null;
    if (!btn || !label) return;

    /* Loading state */
    btn.classList.add('is-loading');
    btn.classList.remove('is-success');
    label.textContent = 'LOCATING...';

    navigator.geolocation.getCurrentPosition(
      function (position) {
        var userLat = position.coords.latitude;
        var userLng = position.coords.longitude;

        /* Calculate distance to every store */
        var storeDistances = [];
        cards.forEach(function (card, i) {
          var lat = parseFloat(card.getAttribute('data-lat'));
          var lng = parseFloat(card.getAttribute('data-lng'));
          if (isNaN(lat) || isNaN(lng)) return;

          var dist = getDistanceKm(userLat, userLng, lat, lng);
          storeDistances.push({ index: i, card: card, distance: dist });
        });

        /* Sort by distance */
        storeDistances.sort(function (a, b) { return a.distance - b.distance; });

        /* Clear previous nearest/distance state */
        cards.forEach(function (c) {
          c.classList.remove('is-nearest');
          var oldBadge = c.querySelector('.sl__card-distance');
          if (oldBadge) oldBadge.remove();
        });

        /* Clean up previous pulse animation */
        if (nearestMarkerEl) {
          nearestMarkerEl.style.animation = '';
          nearestMarkerEl = null;
        }

        /* Re-order the store list in DOM and add distance badges */
        var list = document.querySelector('.sl__list');
        if (list) {
          storeDistances.forEach(function (item, sortIndex) {
            /* Move card in DOM order */
            list.appendChild(item.card);

            /* Add distance badge */
            var nameEl = item.card.querySelector('.sl__card-name');
            if (nameEl) {
              var badge = document.createElement('span');
              badge.className = 'sl__card-distance';
              badge.textContent = formatDistance(item.distance);
              nameEl.insertBefore(badge, nameEl.firstChild.nextSibling);
              /* Place badge after text by appending */
              nameEl.appendChild(badge);
            }

            /* Highlight nearest */
            if (sortIndex === 0) {
              item.card.classList.add('is-nearest');
            }
          });
        }

        /* Pan map to nearest store */
        if (map && storeDistances.length > 0) {
          var nearestIdx = storeDistances[0].index;
          var nearestMarker = markers.find(function (m) { return m._index === nearestIdx; });

          if (nearestMarker) {
            /* Reset all markers to default */
            markers.forEach(function (m) { if (m.setIcon) m.setIcon(defaultIcon); });

            /* Highlight nearest pin */
            nearestMarker.setIcon(createMarkerIcon('#A8BDD4'));

            /* Pan and zoom */
            map.panTo(nearestMarker.getPosition());
            map.setZoom(13);

            /* Open info window */
            var storeName = storeDistances[0].card.getAttribute('data-name');
            var infoWindow = new google.maps.InfoWindow({
              content: '<div style="font-family:sans-serif;font-size:13px;color:#3D2F2A;padding:4px 0;">' +
                '<strong>' + storeName + '</strong><br>' +
                '<span style="color:#A8BDD4;font-size:12px;">Nearest to you</span>' +
                '</div>'
            });
            infoWindow.open(map, nearestMarker);

            /* Pulse animation on marker icon */
            setTimeout(function () {
              var markerImg = document.querySelector('img[src*="' + encodeURIComponent('#A8BDD4').substring(0, 10) + '"]');
              if (markerImg) {
                nearestMarkerEl = markerImg;
                markerImg.style.animation = 'sl-pin-pulse 0.6s ease-in-out 3';
              }
            }, 300);
          }

          /* Select nearest card */
          selectStore(nearestIdx, false);
        }

        /* Success state */
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        label.textContent = '\u2713 SHOWING NEAREST STORES';

        /* Mobile: scroll to map */
        if (window.innerWidth < 768) {
          var mapWrap = document.querySelector('.sl__map-wrap');
          if (mapWrap) {
            mapWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      },
      function () {
        /* Permission denied or error */
        btn.classList.remove('is-loading');
        label.textContent = 'FIND NEAREST STORE';

        var privacy = document.querySelector('.sl__geo-privacy');
        if (privacy) {
          privacy.textContent = 'Enable location access to find your nearest store, or search by city above.';
          privacy.style.color = '#B5A99A';
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 8000,
        maximumAge: 300000
      }
    );
  }

  /* ------ DOM ready fallback for no-API-key mode ------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (!document.getElementById('gulp-map')) {
        initNoMap();
      }
    });
  } else {
    if (!document.getElementById('gulp-map')) {
      initNoMap();
    }
  }
})();
